<dx-data-grid
  #groupDataGrid
  (onCellPrepared)="onCellPreparedSwapSaveIcon($event); onCellPreparedMetricGroup($event)"
  (onEditCanceled)="groupEditStart($event, false)"
  (onEditingStart)="groupEditStart($event, true)"
  (onOptionChanged)="checkEditDeviceTypeValidation.emit()"
  (onRowClick)="onGroupMetricRowClick($event)"
  (onRowInserted)="initMetricGroup($event)"
  (onRowRemoved)="onGroupDeleted($event)"
  (onSaved)="groupEditStart($event, false)"
  (onToolbarPreparing)="editGroupAddRowButton($event)"
  [(selectedRowKeys)]="selectedGroupMetricRow"
  [appRowStateHighlight]="rowStateTracker"
  [appRowStateLockWith]="metricRowStateTracker"
  [columnAutoWidth]="true"
  [dataSource]="this.deviceType?.metricGroups!"
  [disabled]="metricIsBeingEdited"
  [showBorders]="true"
  [showRowLines]="false"
  [wordWrapEnabled]="true"
  height="100%"
  keyExpr="id">

  <dxo-toolbar>
    <dxi-item location="before">
      <div style="display: flex; align-items: center;">
        <p style="font-size:22px; margin: 0 0 0 10px;">{{ 'REGISTRY.DEVICE_TYPE.TABLES.GROUPS' | translate }}</p>
        <app-row-state-badge [trackers]="[rowStateTracker]"></app-row-state-badge>
      </div>
    </dxi-item>
    <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
    </dxi-item>
    <dxi-item locateInMenu="never" location="before" name="addRowButton" showText="inMenu">
    </dxi-item>
  </dxo-toolbar>

  <dxo-paging
    [enabled]="false">
  </dxo-paging>

  <dxo-editing
    [allowAdding]="isEditMode"
    [allowDeleting]="isEditMode"
    [allowUpdating]="isEditMode"
    [newRowPosition]="'last'"
    [useIcons]="true"
    mode="row">
    <dxo-texts
      addRow="{{'BUTTONS.HINTS.ADD' | translate}}"
      cancelRowChanges="{{'BUTTONS.CANCEL' | translate}}"
      deleteRow="{{'BUTTONS.DELETE' | translate}}"
      editRow="{{'BUTTONS.UPDATE' | translate}}"
      saveRowChanges="{{'BUTTONS.CONFIRM' | translate}}">
    </dxo-texts>
  </dxo-editing>

  <dxo-scrolling
    mode="standard"
    showScrollbar="onScroll">
  </dxo-scrolling>

  <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
  </dxo-search-panel>
  <dxo-selection mode="single"></dxo-selection>
  <dxi-column caption="{{'REGISTRY.DEVICE_TYPE.GROUP.NAME' | translate}}"
              dataField="name">
    <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                         [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                         type="stringLength"></dxi-validation-rule>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column caption="{{'REGISTRY.DEVICE_TYPE.GROUP.POLLING_FUNCTION' | translate}}"
              dataField="transportConfiguration.function">
    <dxo-lookup
      [dataSource]="getAvailablePollingFunctions(deviceType)"
      displayExpr="label"
      valueExpr="value">
    </dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column *ngIf="isEditMode" type="buttons" [fixed]="true" fixedPosition="right">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete"></dxi-button>
    <dxi-button icon="copy" [onClick]="onDuplicateGroupClick" hint="{{'REGISTRY.DEVICE_TYPE.BUTTONS.DUPLICATE' | translate}}"></dxi-button>
    <dxi-button template="metricStateCell"></dxi-button>
  </dxi-column>

  <div *dxTemplate="let group of 'metricStateCell'" class="rowStateDotCell">
    <app-row-state-badge [trackers]="[metricRowStateTracker]" [scoped]="true" [scope]="group.data.id"></app-row-state-badge>
  </div>

</dx-data-grid>
